// Classifica valor em faixa para evitar leak de dados financeiros no Sentry Discover.
function amountRange(value) {
  if (value == null) return undefined;
  if (value < 50)   return 'low';       // < R$50
  if (value < 500)  return 'medium';    // R$50–500
  if (value < 5000) return 'high';      // R$500–5k
  return 'very_high';                   // > R$5k
}

const FinancialRepository = {
  /** Falha no saque (POST /withdraw). */
  buildWithdrawContext(ctx = {}) {
    return {
      tags: { flow: 'withdraw', domain: 'financial' },
      extra: {
        amount_range: amountRange(ctx.requestedAmount),
        bank_account_id: ctx.bankAccountId,
        wallet_currency_id: ctx.walletCurrencyId,
        currency_conversion_used: ctx.currencyConversionUsed ?? false,
      },
    };
  },

  /** Falha na antecipação (POST /antecipation). */
  buildAnticipationContext(ctx = {}) {
    return {
      tags: { flow: 'anticipation', domain: 'financial' },
      extra: {
        amount_range: amountRange(ctx.solicitado),
        antecipa_tudo: ctx.anticipaTudo ?? false,
        currency_id: ctx.currencyId,
        api_result: ctx.result,
      },
    };
  },

  /** Falha ao buscar saldo (GET /dashboard?types=statements). */
  buildBalanceFetchContext(ctx = {}) {
    return {
      tags: { flow: 'balance_fetch', domain: 'financial' },
      extra: {
        currency_id: ctx.currencyId,
        types: ctx.types,
      },
    };
  },
};

export default FinancialRepository;
